import customHelper from '$$helpers/custom';
import { formatDate } from '../../helpers/dates';

/**
 * Specifies the text in the task bars and the header of the lightbox
 * @param instance
 * @returns {(function(*, *, *): (string|string))|*}
 */
export default instance => (start, end, task) => {
  const isMultiview = instance.config.multiview;
  const borderElement = '<div class="project-name-and-dates-separator"></div>';
  let text = '';
  let projectName = null;

  if (instance.config.right_side_text === 'rightSideText' && !task.workloadMode) {
    text = '';
  }
  if (instance.config.right_side_text !== 'rightSideText' && task.type === 'project') {
    const start = formatDate(task.start_date);
    const end = formatDate(task.end_date);

    if (isMultiview && task.$level === 1 && instance.config.right_side_text !== 'rightSideText') {
      const project = instance.ganttDataApi.getProjectItem(task.gantt_id);

      if (project) {
        projectName = customHelper.formatTaskName(project.name).trim();
      }
    } else {
      projectName = customHelper.formatTaskName(task.text).trim();
    }
    text = `
      <div class='custom-project-name'>${projectName}</div>
      ${borderElement}
      <div class='custom-project-dates'>${start} - ${end}</div>
    `;
  }
  if (instance.config.right_side_text === 'insideText' && (task.type !== 'project' || task.workloadMode)) {
    text = customHelper.formatTaskName(task.text).trim();
  }
  if (task.deadline && !task.workloadMode && instance.config.right_side_text !== 'rightSideText' && task.type === 'project') {
    if (end.valueOf() > task.deadline.valueOf()) {
      const overdue = Math.ceil(Math.abs((end.getTime() - task.deadline.getTime()) / (24 * 60 * 60 * 1000)));

      text += `
        ${borderElement}
        <div class="custom-overdue">${__('overdue_deadline_task_text', { days: overdue })}</div>
      `;
    }
  }

  return text;
};
